module.exports = __webpack_public_path__ + "static/img/pMRI1.e89ce0eb.png";